import React from "react";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { PUBLIC_ROUTES } from "../../../../../constants";
import { useAppState } from "../../../../../context/StateContext";
import { EmailSentBoxContainer, MainGrid, Title, Text, ClickableText } from "./styles";

export const UpdatedPassword = () => {
  const { currentUser, userLogout } = useAppState();
  const { t: translate } = useTranslation();
  const history = useHistory();

  return (
    <EmailSentBoxContainer>
      <MainGrid justifyContent="center" alignItems="flex-start" spacing={3}>
        <Title>{translate("yourPasswordHasBeenUpdated")}</Title>
        <Text>
          {translate("youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically")}
          <ClickableText aria-label="clickableText" onClick={() => { if (currentUser) userLogout(); history.replace(PUBLIC_ROUTES.SIGN_IN)}}>
            {translate("clickHere")}
          </ClickableText>
        </Text>
      </MainGrid>
    </EmailSentBoxContainer>
  );
};
